import { api } from '../instance';
export const getPage = ({ username, domain }) => {
    const params = new URLSearchParams();
    if (username)
        params.set('username', username);
    if (domain)
        params.set('domain', domain);
    return api.get(`/page/lookup?${params.toString()}`);
};
//# sourceMappingURL=get-page.api.js.map